export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    tenantId: process.env.REACT_APP_MSAL_TENANT_ID,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI
  },
  scopes: process.env.REACT_APP_MSAL_SCOPES,
  logoutRedirectUrl: process.env.REACT_APP_MSAL_LOGOUT_REDIRECT_URL
};
